import axios from "axios";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const BASE_URL = "/loyalty";

async function fetchLoyaltyOffers(token) {
  try {
    //updating Headers
    axios.defaults.headers.common["Authorization"] = `Token ${token}`;

    const { data } = await axios.get(`${SERVER_URL}${BASE_URL}/offers`);

    return data;
  } catch (e) { }
}

async function generateCoupon(input, msisdn, token) {
  const formattedNumber = "233" + msisdn?.substring(1);
  try {
    //updating Headers
    axios.defaults.headers.common["Authorization"] = `Token ${token}`;
    const { data } = await axios.get(
      `${SERVER_URL}${BASE_URL}/generateCoupon?msisdn=${formattedNumber}&input=${input}`
    );

    return data;
  } catch (e) { }
}

async function checkOffers(input, msisdn, token, gps) {
  try {
    //updating Headers
    axios.defaults.headers.common["Authorization"] = `Token ${token}`;
    const { data } = await axios.get(
      `${SERVER_URL}${BASE_URL}/checkCoupon?msisdn=${msisdn}&input=${input}&gps=${gps}`
    );

    return data;
  } catch (e) { }
}

async function fetchCaptureShare(phoneNumber, code, token) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(
      `${SERVER_URL}${BASE_URL}/capturenshare?msisdn=${phoneNumber}&code=${code || ""}`
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function saveCaptureShare(payload, token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}${BASE_URL}/capturenshare`,
      payload
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchEvents(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    // const { data } = await axios.get(`/event`);
    const { data } = await axios.get(`${SERVER_URL}/event`);

    return data;
  } catch (e) {
    throw e;
  }
}

async function getPreviousLiveComments(token, id) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/event/${id}/comments`);

    return data;
  } catch (e) { }
}

async function submitLiveComment(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/event/comment`, payload);

    return data;
  } catch (e) { }
}

async function askQuestion(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/event/ask`, payload);

    return data;
  } catch (e) { }
}

async function fetchMovieList(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/moviemania`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function Vote(token, id) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  const payload = { id };
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/moviemania/vote`,
      payload
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function reserveTicket(token, code) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/moviemania/reserve`,
      { code }
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function reserveDishrackCode(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/loyalty/dishrack/reserve`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function reservePotbellyCode(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/loyalty/potbelly/reserve`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemMovieManiaTicket(token, ticketCode, location) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/moviemania/redeem`,
      { ticketCode, location }
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemDishrackTicket(token, ticketCode, location) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/loyalty/dishrack/redeem`, {
      ticketCode,
      location,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemPotbellyTicket(token, ticketCode, location) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/loyalty/potbelly/redeem`, {
      ticketCode,
      location,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchActiveFeatureRatings(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/feature-ratings`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchMovieManiaRedemptionHistory(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/loyalty/moviemania/history`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchDishrackRedemptionHistory(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/dishrack/history`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchPotbellyRedemptionHistory(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/potbelly/history`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function submitFeatureRatings(
  token,
  { feature, feedbackExperience, feedbackMessage }
) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/loyalty/feature-ratings`, {
      feature,
      feedbackExperience,
      feedbackMessage,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

async function submitYPYCForm(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/ypyc/register`,
      payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function checkYPYCRegistrationStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/ypyc/checkstatus`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function checkMovieManiaStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/moviemania/status`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function checkDishrackStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/dishrack`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function checkPotbellyStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/potbelly`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function getSpeedShoppingData(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/shoppingcart`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function saveShoppingCart(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/shoppingcart`,
      payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function updateUserLocation(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/moviemania/location`,
      payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function checkMovieManiaEligibility(token, code) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/loyalty/moviemania/eligibility/${code}`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchTopLoyaltyList({ token, payload }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(
      `${SERVER_URL}/loyalty/toployaltylist?limit=450`
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchLoyaltyPoints({ token, payload }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(`${SERVER_URL}/loyalty/points`);

    return data;
  } catch (e) {
    throw e;
  }
}

async function postCapturePickupLocation({ token, _id, pickup }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/capturenshare/location`,
      { id: _id, pickup }
    );

    return data;
  } catch (e) {
    throw e;
  }
}

async function checkBlackFridayQualificationStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/loyalty/black-friday`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function fetchInteractions(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/interactions`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function updateBlackFridayPickupLocation(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/black-friday/pickup`, payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function webLogin(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${SERVER_URL}/login/weblogin`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function updateOptInStatus(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/loyalty/opt-in`, payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  fetchLoyaltyOffers,
  generateCoupon,
  fetchCaptureShare,
  saveCaptureShare,
  checkOffers,
  fetchEvents,
  getPreviousLiveComments,
  submitLiveComment,
  askQuestion,
  fetchMovieList,
  Vote,
  reserveTicket,
  reserveDishrackCode,
  redeemMovieManiaTicket,
  redeemDishrackTicket,
  redeemPotbellyTicket,
  fetchMovieManiaRedemptionHistory,
  fetchDishrackRedemptionHistory,
  fetchActiveFeatureRatings,
  submitFeatureRatings,
  submitYPYCForm,
  checkYPYCRegistrationStatus,
  checkMovieManiaStatus,
  checkDishrackStatus,
  getSpeedShoppingData,
  saveShoppingCart,
  updateUserLocation,
  checkMovieManiaEligibility,
  fetchTopLoyaltyList,
  fetchLoyaltyPoints,
  postCapturePickupLocation,
  reservePotbellyCode,
  checkPotbellyStatus,
  fetchPotbellyRedemptionHistory,
  checkBlackFridayQualificationStatus,
  updateBlackFridayPickupLocation,
  fetchInteractions,
  webLogin,
  updateOptInStatus,
};
